import { Select } from "antd";
import { useConcesionadosOptions } from "../../../../hooks/useConcesionadosOptions";

export const Concesionados = ({ handleChange, body }) => {
  const { concesionadosOptions } = useConcesionadosOptions();

  return (
    <Select
      showSearch
      optionFilterProp="label"
      value={body.concesionados}
      placeholder="concesionados"
      style={{ width: "100%" }}
      onChange={(val) => handleChange("concesionados", val)}
      options={concesionadosOptions}
    />
  );
};